<script lang="ts">
	import Header from '$lib/layout/header.svelte';
	import log from '$lib/utils/log';
	import FooterV2 from '$lib/layout/footerV2.svelte';
	import { page } from '$app/state';
	import PageGrid16 from '$lib/storyblok/components/pageGrid16.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import NewsletterBanner from '$lib/storyblok/blocks/newsletterBanner.svelte';

	$effect(() => {
		log.scope('Error Page').error(page.error?.message || 'Error Page', {
			status: page.status,
			route: page.route?.id || '',
			path: page.url.pathname
		});
	});

	let title = $derived(page.status === 404 ? 'Mill | Page Not Found' : 'Mill | Whoops!');
	let description = $derived(
		page.status === 404
			? 'The page you are looking for does not exist.'
			: 'Something went wrong. :('
	);
</script>

<svelte:head>
	<title>{title}</title>
	<meta name="description" content={description} />
	<meta name="robots" content="noindex" />
</svelte:head>

<Header />

<PageGrid16 margin>
	<div class="col-span-full mb-8 mt-36 flex flex-col items-center">
		<img
			src={`/images/error/${page.status === 404 ? '404.png' : 'error.jpg'}`}
			alt=""
			class="mx-auto rounded-2xl sm:w-1/2"
		/>

		<p
			class="mb-6 mt-3 max-w-screen-lg text-balance text-center text-[24px] font-semibold leading-[30px] text-brown-1 lg:mb-8 lg:text-[48px] lg:leading-[52.8px]"
		>
			{#if page.status === 404}
				The page you’re looking for is no longer here.<br />Kind of like your leftovers in a Mill
				Food Recycler. Poof.
			{:else}
				Whoops! Something went wrong. :(
			{/if}
		</p>
		<Button href="/">Go Home</Button>
	</div>
</PageGrid16>

<NewsletterBanner
	content={{
		bg_color: 'green-olive',
		cta_label: 'Submit',
		cta_title: 'Sign up for updates',
		placeholder: 'Enter your email here',
		text: {
			type: 'doc',
			content: [
				{
					type: 'paragraph',
					content: [{ type: 'text', text: 'Stay in the loop.' }]
				},
				{
					type: 'paragraph',
					content: [{ type: 'text', text: 'Subscribe to Mill updates.' }]
				}
			]
		}
	}}
/>
<FooterV2 />
